<template>
  <div class="">
    <div class="w3-padding-large" style="border-bottom: 1px solid #f3efee;">
      <slot name="header"></slot>

      <div class="w3-right">

        <span>
          <slot name="right-header">
          </slot>
        </span>

        <span class="w3-card">
          <slot name="new-issue">
            <router-link :to="{ name: 'newissue' }">
              <i class="fas fa-plus-square fa-lg" style="color: #5e6ad2"></i>
            </router-link>
          </slot>
        </span>
      </div>

      <!-- <div class="w3-right">
        <router-link :to="{ name: 'newissue' }">
          <i class="fas fa-plus-square fa-lg w3-card" style="color: #9262b8"></i>
        </router-link>
      </div> -->
    </div>

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import router from '@/router'

export default {
  name: 'WorkspaceTopbar',
  methods: {},
  computed: mapGetters('auth', ['auth_state', 'user', 'isLoggedIn', 'workspaces']),
}

</script>

<style>
</style>
